module.exports = __webpack_public_path__ + "img/gb6171.prt.5f28b62e.jpg";